import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/apiService";

export const GetOneRecordExpectedObjectivesForStage = createAsyncThunk(
  "PR_ExpectedObjectivesForStage/GetOneRecordExpectedObjectivesForStage",
  async (pR_ExpectedObjectivesForStageId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_ExpectedObjectivesForStage/GetOneRecordExpectedObjectivesForStage",
        pR_ExpectedObjectivesForStageId
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetLisExpectedObjectivesForStageByStageId = createAsyncThunk(
  "PR_ExpectedObjectivesForStage/GetLisExpectedObjectivesForStageByStageId",
  async (model, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_ExpectedObjectivesForStage/GetLisExpectedObjectivesForStageByStageId",
        model
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const UpdateExpectedObjectivesForStageByStageId = createAsyncThunk(
  "PR_ExpectedObjectivesForStage/UpdateExpectedObjectivesForStageByStageId",
  async (update, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_ExpectedObjectivesForStage/UpdateExpectedObjectivesForStageByStageId",
        {
          pR_ExpectedObjectivesForStageId:
            update.pR_ExpectedObjectivesForStageId,
          pR_ObjectiveProjectsId: update.pR_ObjectiveProjectsId,
          pR_ReportsStagesGuid: update.pR_ReportsStagesGuid,
          subObjectives: update.subObjectives,
          percentageMainAndSubObjecive: update.percentageMainAndSubObjecive,
          descriptionOfAchievementOfSubGoals:
            update.descriptionOfAchievementOfSubGoals,
          achievementOfSubGoals: update.achievementOfSubGoals,
          remainingCompletionGoal: update.remainingCompletionGoal,
          canEdit: update.canEdit,
          pR_ReportsId: update.pR_ReportsId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetLisExpectedObjectivesByReportId = createAsyncThunk(
  "PR_ExpectedObjectivesForStage/GetLisExpectedObjectivesByReportId",
  async (update, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_ExpectedObjectivesForStage/GetLisExpectedObjectivesByReportId",
        update
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AddExpectedObjectivesForStage = createAsyncThunk(
  "PR_ExpectedObjectivesForStage/AddExpectedObjectivesForStage",
  async (update, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_ExpectedObjectivesForStage/AddExpectedObjectivesForStage",
        update
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const DeleteExpectedObjectivesForStage = createAsyncThunk(
  "PR_ExpectedObjectivesForStage/DeleteExpectedObjectivesForStage",
  async (update, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_ExpectedObjectivesForStage/DeleteExpectedObjectivesForStage",
        update
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetSpecificRowNoteExpectedObjectivesForStage = createAsyncThunk(
  "GetSpecificRowNoteExpectedObjectivesForStage/GetSpecificRowNoteExpectedObjectivesForStage",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_TechnicalReportNotes/GetPR_TechnicalReportNotesSubmitterData",
        parameters
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      return data;
      // return data.filter((item) => item.incrementNumber - 1 === 1);
      //   return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const ExpectedObjectivesForStage = createSlice({
  name: "ExpectedObjectivesForStage",
  initialState: {
    //-------------------------- ONE -----------------------------------------------
    ExpectedObjectivesForStage: [],
    loadingExpectedObjectivesForStage: false,
    errorExpectedObjectivesForStage: null,
    //-------------------------- List -----------------------------------------------
    LisExpectedObjectivesForStage: [],
    loadingLisExpectedObjectivesForStage: false,
    errorLisExpectedObjectivesForStage: null,
    //-------------------------- update -----------------------------------------------
    UpdateLisExpectedObjectivesForStage: [],
    loadingUpdateLisExpectedObjectivesForStage: false,
    errorUpdateLisExpectedObjectivesForStage: null,
    //-------------------------- Get List By ReportId -----------------------------------------------
    LisExpectedObjectivesForReport: [],
    loadingLisExpectedObjectivesForReport: false,
    errorLisExpectedObjectivesForReport: null,
    //-------------------------- Add-----------------------------------------------
    ExpectedObjectivesAdd: [],
    loadingExpectedObjectivesAdd: false,
    errorExpectedObjectivesAdd: null,
    //-------------------------- Delete-----------------------------------------------
    ExpectedObjectivesDelete: [],
    loadingExpectedObjectivesDelete: false,
    errorExpectedObjectivesDelete: null,
    //-------------------------- Get Specific Row Note -----------------------------------------------

    OneSpecificRowNoteExpectedObjectivesForStage: {},
    loadingOneSpecificRowNoteExpectedObjectivesForStage: false,
    errorOneSpecificRowNoteExpectedObjectivesForStage: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(
        GetOneRecordExpectedObjectivesForStage.pending,
        (state, action) => {
          state.loadingExpectedObjectivesForStage = true;
          state.ExpectedObjectivesForStage = action.payload;
          state.errorExpectedObjectivesForStage = null;
        }
      )
      .addCase(
        GetOneRecordExpectedObjectivesForStage.fulfilled,
        (state, action) => {
          state.loadingExpectedObjectivesForStage = false;
          state.ExpectedObjectivesForStage = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        GetOneRecordExpectedObjectivesForStage.rejected,
        (state, action) => {
          state.loadingExpectedObjectivesForStage = false;
          state.errorExpectedObjectivesForStage = action.payload;
        }
      );
    //---------------------------- list ------------------------------------------
    builder
      .addCase(
        GetLisExpectedObjectivesForStageByStageId.pending,
        (state, action) => {
          state.loadingLisExpectedObjectivesForStage = true;
          state.LisExpectedObjectivesForStage = action.payload;
          state.errorLisExpectedObjectivesForStage = null;
        }
      )
      .addCase(
        GetLisExpectedObjectivesForStageByStageId.fulfilled,
        (state, action) => {
          state.loadingLisExpectedObjectivesForStage = false;
          state.LisExpectedObjectivesForStage = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        GetLisExpectedObjectivesForStageByStageId.rejected,
        (state, action) => {
          state.loadingLisExpectedObjectivesForStage = false;
          state.errorLisExpectedObjectivesForStage = action.payload;
        }
      );

    //---------------------------- update ------------------------------------------
    builder
      .addCase(
        UpdateExpectedObjectivesForStageByStageId.pending,
        (state, action) => {
          state.loadingUpdateLisExpectedObjectivesForStage = true;
          state.UpdateLisExpectedObjectivesForStage = action.payload;
          state.errorUpdateLisExpectedObjectivesForStage = null;
        }
      )
      .addCase(
        UpdateExpectedObjectivesForStageByStageId.fulfilled,
        (state, action) => {
          state.loadingUpdateLisExpectedObjectivesForStage = false;
          state.UpdateLisExpectedObjectivesForStage = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        UpdateExpectedObjectivesForStageByStageId.rejected,
        (state, action) => {
          state.loadingUpdateLisExpectedObjectivesForStage = false;
          state.errorUpdateLisExpectedObjectivesForStage = action.payload;
        }
      );
    //---------------------------- Get List By Report Id ------------------------------------------

    builder
      .addCase(GetLisExpectedObjectivesByReportId.pending, (state, action) => {
        state.LisExpectedObjectivesForReport = true;
        state.LisExpectedObjectivesForReport = action.payload;
        state.errorLisExpectedObjectivesForReport = null;
      })
      .addCase(
        GetLisExpectedObjectivesByReportId.fulfilled,
        (state, action) => {
          state.LisExpectedObjectivesForReport = false;
          state.LisExpectedObjectivesForReport = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(GetLisExpectedObjectivesByReportId.rejected, (state, action) => {
        state.LisExpectedObjectivesForReport = false;
        state.errorLisExpectedObjectivesForReport = action.payload;
      });
    //---------------------------- Add ------------------------------------------

    builder
      .addCase(AddExpectedObjectivesForStage.pending, (state, action) => {
        state.loadingExpectedObjectivesAdd = true;
        state.ExpectedObjectivesAdd = action.payload;
        state.errorExpectedObjectivesAdd = null;
      })
      .addCase(AddExpectedObjectivesForStage.fulfilled, (state, action) => {
        state.loadingExpectedObjectivesAdd = false;
        state.ExpectedObjectivesAdd = action.payload; // Assuming payload has the desired data
      })
      .addCase(AddExpectedObjectivesForStage.rejected, (state, action) => {
        state.loadingExpectedObjectivesAdd = false;
        state.errorExpectedObjectivesAdd = action.payload;
      });
    //---------------------------- Delete ------------------------------------------

    builder
      .addCase(DeleteExpectedObjectivesForStage.pending, (state, action) => {
        state.loadingExpectedObjectivesDelete = true;
        state.ExpectedObjectivesDelete = action.payload;
        state.errorExpectedObjectivesDelete = null;
      })
      .addCase(DeleteExpectedObjectivesForStage.fulfilled, (state, action) => {
        state.loadingExpectedObjectivesDelete = false;
        state.ExpectedObjectivesDelete = action.payload; // Assuming payload has the desired data
      })
      .addCase(DeleteExpectedObjectivesForStage.rejected, (state, action) => {
        state.loadingExpectedObjectivesDelete = false;
        state.errorExpectedObjectivesDelete = action.payload;
      })
      //---------------------------- Get Specific Row Note ------------------------------------------
      .addCase(
        GetSpecificRowNoteExpectedObjectivesForStage.pending,
        (state, action) => {
          state.loadingOneSpecificRowNoteExpectedObjectivesForStage = true;
          state.OneSpecificRowNoteExpectedObjectivesForStage = action.payload;
          state.errorOneSpecificRowNoteExpectedObjectivesForStage = null;
        }
      )
      .addCase(
        GetSpecificRowNoteExpectedObjectivesForStage.fulfilled,
        (state, action) => {
          state.loadingOneSpecificRowNoteExpectedObjectivesForStage = false;
          state.OneSpecificRowNoteExpectedObjectivesForStage = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        GetSpecificRowNoteExpectedObjectivesForStage.rejected,
        (state, action) => {
          state.loadingOneSpecificRowNoteExpectedObjectivesForStage = false;
          state.errorOneSpecificRowNoteExpectedObjectivesForStage =
            action.payload;
        }
      );
  },
});

export default ExpectedObjectivesForStage.reducer;
